import BannerRepository from '../../repositories/BannerRepository'

const state = {
  banners: [],
  banner: {},
  error: ''
}

const getters = {
}

const actions = {
  async get({ commit }) {
    await BannerRepository.get()
      .then(resp => {
        commit('setBanners', resp.data.data)
      })
  },
  async detail({ commit }, id){
    await BannerRepository.detail(id)
      .then(resp => {
        commit('setBanner', resp.data.data)
      })
  },
  async put({ commit, dispatch }, payload){
    await BannerRepository.put(payload)
      .then(() => {
        commit('setError', '')
        dispatch('get')
      })
  },
  async post({ commit, dispatch }, payload){
    await BannerRepository.post(payload)
      .then(() => {
        commit('setError', '')
        dispatch('get')
      }).catch(error => {
        commit('setError', error.response.data.message)
      })
  },
  async delete({ commit, dispatch }, id){
    await BannerRepository.delete(id)
      .then(() => {
        commit('setError', '')
        dispatch('get')
      })
  },
  setError({ commit }){
    commit('setError', '')
  },
}

const mutations = {
  setBanners (state, data) {
    state.banners = data
  },
  setBanner (state, data) {
    state.banner = data
  },
  setError(state, msg){
    state.error = msg
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
